import React from 'react';
import PropTypes from 'prop-types';
import { slide as Menu } from 'react-burger-menu';
import { Nav } from 'react-bootstrap';
import './styles.scss';
function BurgerMenu ({
     sections=[], 
     selectedKey='/home', 
     onSectionSelected, 
     openMenu=false, 
     setOpenMenu, 
     isRight=false
    }) {

  const handleStateChange = (state) => {
    setOpenMenu(state.isOpen)
  }
    return (
      <div className='burgerMenuContainer'>
        <Menu 
              right={isRight} 
              isOpen = {openMenu} 
              onStateChange={(state) => handleStateChange(state)}
              bodyClassName={"disableScroll"}
            >
               <Nav>
                {
                  sections?.map((section)=> 
                  <Nav.Link className={( selectedKey == section.url) ? 'active': ''} key={section.url} onClick={()=>onSectionSelected( section.isHome ? '/' : section.url)}>{section.name}</Nav.Link>
                  )
                }  
                </Nav>
        </Menu>
        </div>

    )
}

BurgerMenu.propTypes = {
  sections: PropTypes.array.isRequired,
  selectedKey: PropTypes.string.isRequired,
  onSectionSelected: PropTypes.func.isRequired,
  openMenu: PropTypes.bool,
  setOpenMenu: PropTypes.func.isRequired,
  isRight: PropTypes.bool
};

export default React.memo(BurgerMenu);
